import { MessageMedium } from 'constants/messageMediums';
import { useState } from 'react';
import noop from 'utils/noop';
import { useCampaign } from '../../BaseSendEditor.hooks';
import { BaseSendEditorProps } from '../../BaseSendEditor.types';
import { SelectiveTargetingBaseProps } from './SelectiveTargeting.types';
import { EmptyStateProps, SelectiveTargetingEmptyState } from './SelectiveTargetingEmptyState';

interface SelectiveTargetingItemProps extends BaseSendEditorProps {
  SelectComponent: React.ComponentType<React.PropsWithChildren<SelectiveTargetingBaseProps>>;
  EmptyComponent?: React.ComponentType<React.PropsWithChildren<EmptyStateProps>>;
  expectedMessageMedium: MessageMedium;
  isShown?: boolean;
  onChange?: (mobileAppIds: number[]) => void;
}

export const SelectiveTargetingItem = (props: SelectiveTargetingItemProps) => {
  const {
    EmptyComponent = SelectiveTargetingEmptyState,
    SelectComponent,
    expectedMessageMedium,
    isShown = false,
    messageMedium,
    onChange = noop,
    isDisabled = false,
  } = props;
  const { campaign } = useCampaign();
  const { mobileAppIds = [] } = campaign;
  const [isEnabled, setIsEnabled] = useState(!!mobileAppIds.length);
  const [appIdsCache, setAppIdsCache] = useState(mobileAppIds);

  const handleAppIdsUpdate = (appIds: number[] = []) => {
    setAppIdsCache(appIds);
    onChange(appIds);
  };

  const handleEnabledUpdate = (isChecked: boolean) => {
    setIsEnabled(isChecked);
    onChange(isChecked ? appIdsCache : []);
  };

  if (isShown) {
    return (
      <SelectComponent
        {...props}
        mobileAppIds={mobileAppIds}
        setMobileAppIds={handleAppIdsUpdate}
        isSelectiveTargetingEnabled={isEnabled}
        setIsSelectiveTargetingEnabled={handleEnabledUpdate}
        isDisabled={isDisabled}
      />
    );
  }

  return messageMedium === expectedMessageMedium ? (
    <EmptyComponent messageMedium={messageMedium} />
  ) : null;
};

export default SelectiveTargetingItem;
